import React from 'react';

const BookingSection = ({ t, onOpenConsultationForm }) => {
  const handleCTAClick = () => {
    onOpenConsultationForm();
  };

  return (
    <section className="py-20 bg-[#FAF9F7]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2
              className="text-4xl sm:text-5xl font-light text-[#2C2C2C] mb-6"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              {t.bookingSection.title}
            </h2>
            <div className="w-24 h-1 bg-[#C4B5A0] mx-auto mb-6"></div>
            <p className="text-lg text-[#8B7D6B] leading-relaxed max-w-3xl mx-auto">
              {t.bookingSection.description}
            </p>
          </div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {t.bookingSection.steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-6">
                  <div className="w-20 h-20 mx-auto rounded-full bg-gradient-to-br from-[#C4B5A0] to-[#8B4513] flex items-center justify-center shadow-lg">
                    <span
                      className="text-3xl font-light text-white"
                      style={{ fontFamily: 'Cormorant Garamond, serif' }}
                    >
                      {step.number}
                    </span>
                  </div>
                  {index < t.bookingSection.steps.length - 1 && (
                    <div className="hidden md:block absolute top-10 left-1/2 w-full h-0.5 bg-[#D4C4B0]" style={{ transform: 'translateX(10%)' }}></div>
                  )}
                </div>
                <h3
                  className="text-xl font-light text-[#2C2C2C] mb-3"
                  style={{ fontFamily: 'Cormorant Garamond, serif' }}
                >
                  {step.title}
                </h3>
                <p className="text-[#8B7D6B] leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center bg-gradient-to-br from-[#F5F3F0] to-[#FAF9F7] rounded-lg p-10 shadow-md">
            <h3
              className="text-3xl font-light text-[#2C2C2C] mb-4"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              {t.bookingSection.cta}
            </h3>
            <p className="text-[#8B7D6B] mb-8 max-w-2xl mx-auto">
              {t.bookingSection.ctaSubtitle}
            </p>
            <button
              onClick={handleCTAClick}
              className="inline-flex items-center justify-center px-8 py-4 text-base font-medium tracking-wider uppercase text-white bg-[#8B4513] border-2 border-[#8B4513] rounded-md transition-all duration-300 hover:bg-[#A0522D] hover:border-[#A0522D] hover:shadow-lg hover:-translate-y-1"
            >
              {t.hero.cta}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
